import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

import { Cacheable, CacheableItem } from '@/lib/cacheable';

type AxiosCachedRequestConfig = AxiosRequestConfig & {
  expiresAt?: CacheableItem['expiresAt'];
  cacheKey?: string;
};

type AxiosCachedResponse<T> = Pick<AxiosResponse<T>, 'data'>;

export const axiosCacheableAdapter = (
  client: AxiosInstance,
  cacheable: Cacheable
) => {
  const request = <T>({
    expiresAt,
    cacheKey: _cacheKey,
    ...config
  }: AxiosCachedRequestConfig): Promise<AxiosCachedResponse<T>> => {
    const cacheKey = _cacheKey || JSON.stringify(config);
    return cacheable.remember(
      cacheKey,
      async () => {
        const response = await client.request(config);
        return {
          data: response.data,
        };
      },
      expiresAt
    );
  };

  return {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get: <T = any>(url: string, config: AxiosCachedRequestConfig) => {
      return request<T>({
        ...config,
        url,
      });
    },
  };
};
